import React, { useState } from "react";


import {
  FaBolt,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function EnergyUtilitiesPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Grid & Power",
      points: [
        "Load Forecasting Agent",
        "Grid Failure Prediction Agent",
        "Smart Meter Reading Agent",
        "Load Balancing Agent",
        "Outage Management Agent",
      ],
    },

    {
      title: "Renewable Energy",
      points: [
        "Solar Panel Health Agent",
        "Wind Turbine Efficiency Agent",
        "Storage Battery Prediction Agent",
        "Renewable Forecast Integration Agent",
        "PV Panel Cleaning Scheduler Agent",
      ],
    },

    {
      title: "Smart Utilities",
      points: [
        "Smart City Lighting Control Agent",
        "Water Leak Detection Agent",
        "Smart Water Metering Agent",
        "HVAC Optimization Agent",
        "Appliance Usage Profiling Agent",
      ],
    },

    {
      title: "Oil, Gas & Extraction",
      points: [
        "Pipeline Leak Detection Agent",
        "Drilling Optimization Agent",
        "Equipment Wear Prediction Agent",
        "Extraction Site Planning Agent",
        "Safety Monitoring Agent",
      ],
    },

    {
      title: "Analytics & Sustainability",
      points: [
        "Energy Billing Optimization Agent",
        "Carbon Credit Compliance Agent",
        "Power Outage Root Cause Agent",
        "ESG Reporting Agent",
        "Customer Usage Pattern Agent",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .energy-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .energy-hero {
          background: #173b8f;
          width: 100%;
        }

        .energy-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .energy-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .energy-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .energy-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .energy-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .energy-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .energy-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .energy-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .energy-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .energy-card-header.active {
          background: #173b8f;
        }

        .energy-card-header.inactive {
          background: #ffffff;
        }

        .energy-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .energy-card-title.active {
          color: #ffffff;
        }

        .energy-card-title.inactive {
          color: #173b8f;
        }

        .energy-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .energy-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .energy-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .energy-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .energy-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .energy-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .energy-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .energy-hero-inner {
            padding: 32px 0px;
          }

          .energy-title {
            font-size: 30px;
          }

          .energy-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .energy-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .energy-icon-box {
            width: 40px;
            height: 40px;
          }

          .energy-icon-box svg {
            font-size: 18px;
          }

          .energy-title {
            font-size: 26px;
          }

          .energy-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .energy-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .energy-card-header {
            padding: 12px 16px;
          }

          .energy-card-title {
            font-size: 15px;
          }

          .energy-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .energy-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .energy-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .energy-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .energy-icon-box svg {
            font-size: 16px;
          }

          .energy-title {
            font-size: 21px;
          }

          .energy-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .energy-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .energy-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .energy-card-header {
            padding: 10px 14px;
          }

          .energy-card-title {
            font-size: 14px;
          }

          .energy-card-content {
            padding: 14px 14px;
          }

          .energy-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .energy-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .energy-point-check svg {
            font-size: 9px;
          }

          .energy-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .energy-title {
            font-size: 18px;
          }

          .energy-card-title {
            font-size: 13px;
          }

          .energy-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="energy-wrapper">
        {/* HERO SECTION */}
        <div className="energy-hero">
          <div className="energy-hero-inner">
            <div className="energy-hero-top">
              <div className="energy-icon-box">
                <FaBolt />
              </div>

              <h1 className="energy-title">Energy & Utilities</h1>
            </div>

            <p className="energy-description">
              This sector involves the generation, transmission, distribution, and management of energy (electricity, gas, water, renewables). It’s critical to both infrastructure and sustainability goals.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="energy-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="energy-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`energy-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`energy-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="energy-chevron-active" />
                  ) : (
                    <FaChevronDown className="energy-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="energy-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="energy-point-row">
                        <div className="energy-point-check">
                          <FaCheck />
                        </div>

                        <p className="energy-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default EnergyUtilitiesPage;
